module.exports = __webpack_public_path__ + "img/vrata.b1e6e793.svg";